import React from 'react';
import { describe, PropTypes } from '@elliemae/ds-props-helpers';
import { styled, border, truncate, withTheme, __UNSAFE_SPACE_TO_DIMSUM } from '@elliemae/ds-system';
import { Grid } from '@elliemae/ds-grid';

const StyledContainer = styled(Grid)`
  background: ${(props) => props.theme.colors.neutral['000']};
  border-bottom: ${(props) => border(props.theme.colors.neutral['300'])};
`;
const StyledTitle = styled.div`
  font-weight: ${(props) => props.theme.fontWeights.semibold};
  font-size: 13px;
  color: ${(props) => props.theme.colors.neutral['800']};
  ${truncate()}
`;

const MobileListItem = ({
  leftAddon = null,
  rightAddon = null,
  title = '',
  value = '',
  dataTestid = 'mobile-list-item',
  theme,
}) => {
  const cols = [1];
  if (leftAddon) cols.unshift(__UNSAFE_SPACE_TO_DIMSUM(theme.space.m));
  if (rightAddon) cols.push(__UNSAFE_SPACE_TO_DIMSUM(theme.space.m));
  return (
    <StyledContainer
      cols={cols}
      height="40px"
      width="100%"
      pl={__UNSAFE_SPACE_TO_DIMSUM(theme.space.s)}
      pr={__UNSAFE_SPACE_TO_DIMSUM(theme.space.s)}
      gutter="xs"
      data-testid={`${dataTestid}--${value}`}
    >
      {leftAddon && <Grid alignItems="center">{leftAddon}</Grid>}
      <Grid alignItems="center">
        <StyledTitle>{title}</StyledTitle>
      </Grid>
      {rightAddon && (
        <Grid alignItems="center" justifyContent="center">
          {rightAddon}
        </Grid>
      )}
    </StyledContainer>
  );
};

const DSMobileListItem = withTheme(MobileListItem);

const listItemProps = {
  leftAddon: PropTypes.element.description('Element placed at the left'),
  rightAddon: PropTypes.element.description('Element placed at the right'),
  title: PropTypes.string.description('Item s title').isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).description(
    'Item s value, used for data-testid attr',
  ),
  dataTestid: PropTypes.string.description('ID used for testing').defaultValue('mobile-list-item'),
  theme: PropTypes.object.description(''),
};

MobileListItem.displayName = 'MobileListItem';
const ListItemWithSchema = describe(MobileListItem);
ListItemWithSchema.propTypes = listItemProps;

export { DSMobileListItem, ListItemWithSchema };
